export const VITE_OLYMPIADS_PATH_TO_FILES="https://179202.selcdn.ru/cabinet-municipality"